var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92216 0.49752L6.85323 5.495H5.56027L6.62932 0.49752H7.92216ZM13.3615 3.72445L14.042 1.8478L14.4336 3.72445H13.3615ZM14.8045 5.495H16L14.9556 0.49752H13.8528C13.6043 0.49752 13.3948 0.641618 13.302 0.863836L11.3621 5.495H12.7199L12.9894 4.74865H14.6479L14.8045 5.495ZM11.4294 3.86349C11.435 2.54457 9.60616 2.47151 9.61841 1.88219C9.62235 1.70314 9.7932 1.51239 10.1666 1.46361C10.3517 1.43978 10.8626 1.42045 11.4417 1.68729L11.6682 0.627119C11.3571 0.514605 10.9569 0.40625 10.4588 0.40625C9.18072 0.40625 8.28162 1.08515 8.27443 2.0581C8.26622 2.77758 8.91669 3.17874 9.40575 3.41838C9.90998 3.66331 10.0789 3.82033 10.0764 4.03918C10.073 4.37447 9.67439 4.52295 9.30324 4.52857C8.65288 4.53869 8.27589 4.35278 7.97544 4.21272L7.74075 5.3083C8.04333 5.44678 8.60084 5.56727 9.17813 5.57345C10.537 5.57345 11.4254 4.90253 11.4294 3.86349ZM6.07473 0.49752L3.97991 5.495H2.61345L1.5825 1.50666C1.52 1.2614 1.46549 1.17125 1.27542 1.06762C0.964517 0.898793 0.451292 0.740869 0 0.64263L0.0305735 0.49752H2.23049C2.51071 0.49752 2.76283 0.683994 2.82701 1.00681L3.37159 3.8989L4.71648 0.49752H6.07473Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIconSm);
export default __webpack_public_path__ + "static/media/visa-icon-sm.3028734afcb95f475770e5639f5db87f.svg";
export { ForwardRef as ReactComponent };